import { makeStyles } from "@material-ui/core/styles";

export const buttonStyles = makeStyles({
  primary: {
    borderRadius: "3px !important",
    border: 0,
    height: 48,
    padding: "0 30px",
    // boxShadow: "0 3px 5px 2px rgba(181, 181, 181, .71)",
    textTransform: "capitalize",
    fontSize: 14
  },
  label: {
    textTransform: "capitalize"
  },
  questionButtonsContainer: {
    padding: "5px 20px !important",
    textTransform: "none !important",
  },
  deckCardButtons: {
    padding: "8px !important",
    // marginTop: "15px !important",
    // marginLeft: "15px !important",
    spacing: 1,
    background: "linear-gradient(45deg, #FCFDFC 30%, #FCFDFC 90%)",
    color: "rgba(152, 152, 152, 1)"
  },
  deckCardButtonText: {
    marginTop: "4px",
    color: "rgba(152, 152, 152, 1)",
    fontSize: "0.6em",
    textAlign: "center",
    fontWeight: "700"
  },
  answerButtons: {
    padding: 10
  },
  homeDeckButton: {
    width: "5em",
    height: "7em !important",
    marginLeft: "8px",
    marginBottom: "8px",
    padding: "4px !important",
    borderRadius: "8px !important",
    transition: "none !important",
    boxShadow: "2px 3px 5px rgba(170,175,167, .5) !important"
  },
  deckButtons: {
    color: "rgba(152, 152, 152, 1)"
  },
  homeCustomDeckButtons: {
    height: "5em"
  },
  otherAnswerOptions: {
    borderRadius: "0 !important"
  },
  firstAnswerOption: {
    borderBottomRightRadius: "0 !important",
    borderBottomLeftRadius: "0 !important"
  },
  lastAnswerOption: {
    borderTopRightRadius: "0 !important",
    borderTopLeftRadius: "0 !important"
  },
  lastHomeDeckButon: {
    paddingRight: 20
  },
  answerOptions: {
    padding: "10px 5px"
  }
});
